import { Button, Flex, Input, Select, Spinner, TableContainer, Text } from '@chakra-ui/react'
import { HeadingPages } from '../../../components/HeadingPages'
import * as T from '../../../components/Table'
import { useForm } from 'react-hook-form'
import { z } from 'zod'
import { zodResolver } from '@hookform/resolvers/zod'
import { api } from '../../../services/api'
import { useQuery } from 'react-query'
import { RelatorioLista } from './RelatorioLista'
import { useEnterprise } from '../../../hooks/useEnterprise'
import { GerarExcel } from './GerarExcel'
import { GerarPdf } from './GerarPdf'
import { useEffect, useState } from 'react'

async function getRecebimentoDeConsumo({ dataInicial, dataFinal }) {
  const res = await api.get('site/v2/fiscal/lista-recebimento-consumo', {
    params: {
      data_inicial: dataInicial,
      data_final: dataFinal,
    },
  })

  return res.data
}

const schema = z
  .object({
    dataInicial: z.string().optional(),
    dataFinal: z.string().optional(),
  })
  .refine((data) => !(data.dataInicial && !data.dataFinal), {
    message: 'Data final é obrigatória quando data inicial é fornecida',
    path: ['dataFinal'],
  })
  .refine((data) => !(data.dataFinal && !data.dataInicial), {
    message: 'Data inicial é obrigatória quando data final é fornecida',
    path: ['dataInicial'],
  })

export function RecebimentoDeConsumo() {
  const {
    register,
    handleSubmit,
    formState: { errors, isSubmitting },
    setValue,
  } = useForm({
    resolver: zodResolver(schema),
  })

  const { data: enterprises = [] } = useEnterprise()

  const [filters, setFilters] = useState({})

  const {
    data = [],
    isLoading,
    isRefetching,
  } = useQuery(
    ['recebimento-de-consumo', filters],
    () =>
      getRecebimentoDeConsumo({
        dataInicial: filters.dataInicial,
        dataFinal: filters.dataFinal,
      }),
    {
      keepPreviousData: true,
      refetchOnWindowFocus: false,
      staleTime: 1000 * 60 * 5,
    }
  )

  const onSubmit = async (data) => {
    setFilters(data)
  }

  useEffect(() => {
    const date = new Date()
    const firstDay = new Date(date.getFullYear(), date.getMonth(), 1)
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    setValue('dataInicial', firstDay.toISOString().split('T')[0])
    setValue('dataFinal', lastDay.toISOString().split('T')[0])

    setFilters({
      dataInicial: firstDay.toISOString().split('T')[0],
      dataFinal: lastDay.toISOString().split('T')[0],
    })
  }, [setValue])

  return (
    <>
      <HeadingPages name="Recebimento de Consumo" />

      <Flex my={10} maxW="1200px" w="full" mx="auto" flexDir="column" justifyContent="center" alignItems="center" gap={2}>
        <Flex alignItems="end" justifyContent="center" gap={2} as="form" onSubmit={handleSubmit(onSubmit)}>
          <Flex flexDir="column">
            <Text as="label" fontSize="sm" htmlFor="data-inicial">
              Data Inicial
            </Text>
            <Input {...register('dataInicial')} id="data-inicial" size="sm" type="date" />
          </Flex>
          <Flex flexDir="column">
            <Text as="label" fontSize="sm" htmlFor="data-final">
              Data Final
            </Text>
            <Input {...register('dataFinal')} size="sm" type="date" id="data-final" />
          </Flex>

          <Button
            isLoading={isLoading || isRefetching}
            loadingText="Buscando..."
            size="sm"
            colorScheme="blue"
            ml="4"
            maxW="120px"
            w="full"
            type="submit"
          >
            Buscar
          </Button>
        </Flex>

        {/* {data?.length > 0 && (
          <Flex alignItems="center" gap={2}>
            <GerarExcel data={data} />
            <GerarPdf data={data} />
          </Flex>
        )} */}

        {errors.dataFinal && (
          <Text size="xs" color="red.500">
            {errors.dataFinal.message}
          </Text>
        )}
        {errors.dataInicial && (
          <Text size="xs" color="red.500">
            {errors.dataInicial.message}
          </Text>
        )}
      </Flex>

      {data && (
        <TableContainer>
          <T.Table>
            <T.Thead>
              <T.Th>Pedido de Compra</T.Th>
              <T.Th>Fornecedor</T.Th>
              <T.Th>Descrição produto</T.Th>
              <T.Th>Codigo do Produto</T.Th>
              <T.Th>Quantidade</T.Th>
              <T.Th>Validar</T.Th>
            </T.Thead>
            <T.Tbody>
              {!isLoading && <RelatorioLista data={data} />}

              {isLoading && (
                <T.Tr>
                  <T.Td colSpan="14" textAlign="center">
                    Carregando... <Spinner size="sm" />
                  </T.Td>
                </T.Tr>
              )}
            </T.Tbody>
          </T.Table>
        </TableContainer>
      )}
    </>
  )
}
